import * as React from 'react';
import * as _ from 'lodash';
import { toast } from 'react-toastify';
import { arrayMove } from 'react-sortable-hoc';
import { confirmAlert } from 'react-confirm-alert';
import ModuleList from 'src/components/Module/list';
import { Module } from 'src/models/module';
import * as Api from 'src/api';

export default class ModuleIndexContainer extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      contentId: this.props.match.params.contentId,
      modules: [],
    };

    this.fetch = this.fetch.bind(this);
    this.delete = this.delete.bind(this);
    this.changeOrder = this.changeOrder.bind(this);
  }

  public async fetch(): Promise<void> {
    const query: any = {
      limit: 200,
      content_id: this.state.contentId,
      order: 'position ASC',
    };

    const response: any = await Api.listModules(query);
    const modules: Module[] = response.data;

    this.setState({ modules });
  }

  public async delete(id: number): Promise<any> {
    confirmAlert({
      title: 'Confirmar',
      message: '¿Desea eliminar?',
      buttons: [
        {
          label: 'Si',
          onClick: async () => {
            await Api.deleteModule(id);
            toast.success('El registro fue eliminado');
            this.fetch();
          },
        },
        {
          label: 'No',
        }
      ]
    });
  }

  public changeOrder({ oldIndex, newIndex }: { oldIndex: number, newIndex: number }) {
    this.setState({
      modules: arrayMove(this.state.modules, oldIndex, newIndex),
    }, async () => {
      let modules: Module[] = _.cloneDeep(this.state.modules);
      modules = modules.map((mod: Module, index: number): Module => {
        mod.position = index + 1;

        return mod;
      });

      this.setState({ modules });

      const body = modules.map((mod: Module): any => {
        return {
          id: mod.id,
          position: mod.position,
        }
      });
      await Api.reorderModules(body);
    });
  }

  public render() {
    return (
      <ModuleList
        modules={this.state.modules}
        onSortEnd={this.changeOrder}
        contentId={this.state.contentId}
        onDelete={this.delete}
      />
    );
  }

  public componentDidMount() {
    this.fetch();
  }
}



// WEBPACK FOOTER //
// ./src/containers/Module/index.tsx